<template>
    <app-content-admin>
        <template slot="header">{{$t("merchant_new")}}</template>

        <v-layout row wrap>

            <v-flex xs12>
                <v-card>

                    <v-card-text>
                        <v-form ref="form" v-model="valid" autocomplete="off">
                            <v-card-title>
                                {{ $t('store_detail') }}
                            </v-card-title>
                            <v-container fluid grid-list-xs>

                                <v-layout wrap>

                                    <v-flex xs12 md6 lg4>
                                        <v-text-field
                                            :label="$t('brand')"
                                            v-model="form.brand"
                                            :rules="[rules.required('brand'), rules.max_length('brand', 30)]"
                                            counter="30"
                                            clearable
                                            outlined
                                        >
                                        </v-text-field>
                                    </v-flex>

                                    <v-flex xs12 md6 lg4>
                                        <v-text-field
                                            :label="$t('short_brand')"
                                            v-model="form.short_brand"
                                            :rules="[rules.required('short_brand'), rules.max_length('short_brand', 11)]"
                                            counter="11"
                                            clearable
                                            :hint="$t('character_only', {no: 11})"
                                            outlined
                                        >
                                        </v-text-field>
                                    </v-flex>

                                    <v-flex xs12 md6 lg4>
                                        <v-text-field
                                            v-model="form.point_brand"
                                            :label="$t('point_brand')"
                                            :rules="[rules.required('point_brand')]"
                                            item-value="value"
                                            item-text="name"
                                            outlined
                                        >
                                        </v-text-field>
                                    </v-flex>

                                    <v-flex xs12 lg6>
                                        <v-textarea
                                            v-model="form.description"
                                            :label="$t('description')"
                                            item-value="value"
                                            item-text="name"
                                            outlined
                                        >
                                        </v-textarea>
                                    </v-flex>

                                    <v-flex xs12 lg6>
                                        <v-textarea
                                            v-model="form.address"
                                            :label="$t('address')"
                                            item-value="value"
                                            item-text="name"
                                            outlined
                                        >
                                        </v-textarea>
                                    </v-flex>

                                    <v-flex xs12 lg6>
                                        <v-autocomplete
                                            v-model="form.state"
                                            :label="$t('state')"
                                            :items="states"
                                            item-value="id"
                                            item-text="name"
                                            outlined
                                        >
                                        </v-autocomplete>
                                    </v-flex>

                                    <v-flex xs12>
                                        <v-textarea
                                            v-model="form.operating_hour"
                                            :label="$t('operating_hour')"
                                            item-value="value"
                                            item-text="name"
                                            outlined
                                        >
                                        </v-textarea>
                                    </v-flex>

                                    <v-flex xs12 md6>
                                        <v-text-field
                                            v-model="form.website_url"
                                            :label="$t('website_url')"
                                            type="url"
                                            outlined
                                        >
                                        </v-text-field>
                                    </v-flex>

                                    <v-flex xs12 md6>
                                        <v-text-field
                                            v-model="form.facebook_url"
                                            :label="$t('facebook_url')"
                                            type="url"
                                            outlined
                                        >
                                        </v-text-field>
                                    </v-flex>

                                    <v-flex xs12 md6>
                                        <label>{{ $t('store_image')}}</label>
                                        <vue-dropzone
                                            ref="image"
                                            @vdropzone-success="uploadCallback"
                                            :options="dropzone_option"
                                            @vdropzone-removed-file="removedCallback">
                                        </vue-dropzone>
                                    </v-flex>



                                </v-layout>
                            </v-container>

                            <v-card-title>
                                {{ $t('account_detail') }}
                            </v-card-title>
                            <v-container fluid grid-list-xs>
                                <v-layout row wrap>
                                    <v-flex xs12 md6 lg4>
                                        <v-text-field
                                            :label="$t('name')"
                                            v-model="form.name"
                                            :rules="[rules.required('name')]"
                                            counter="30"
                                            clearable
                                            outlined
                                        >
                                        </v-text-field>
                                    </v-flex>

                                    <v-flex xs12 md6 lg4>
                                        <v-text-field
                                            :label="$t('email')"
                                            v-model="form.email"
                                            :rules="[rules.required('email')]"
                                            outlined
                                        >
                                        </v-text-field>
                                    </v-flex>

                                    <v-flex xs12 md6 lg4>
                                        <v-text-field
                                            :label="$t('mobile_no')"
                                            v-model="form.mobile_no"
                                            :rules="[rules.required('mobile_no'), rules.number]"
                                            outlined
                                            prefix="+60"
                                        >
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            @click="submit()"
                        >
                            {{ $t('submit') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>

            </v-flex>

        </v-layout>

    </app-content-admin>

</template>

<script>
    import Dropzone from '@/mixins/Dropzone'
    import vForm from '@/mixins/vForm'

    export default {
        mixins: [Dropzone, vForm],

        data(){
            return{
                form:{
                    brand: null,
                    short_brand: null,
                    point_brand: null,
                    description: null,
                    address: null,
                    state: null,
                    operating_hour:null,
                    website_url: null,
                    facebook_url: null,
                    files: [],
                    name: null,
                    email: null,
                    mobile_no: null,
                },
                dropzone_option: this.dropzoneOptions('image', api.path('merchant.upload')),
                states:[]

          }
        },

        mounted(){
            this.getState();
        },
        methods: {
            async submit() {
                let loader = this.$loading.show();

                await axios.post(api.path('merchant.create'), this.form)
                .then(res => res.data)
                    .then(res =>  {
                        this.$toastr.s(this.$t(res.message));
                        this.$router.push({
                            name: 'merchant_edit',
                            params: {id: res.data.id},
                            query: {type: 'new'}
                        })
                        loader.hide();
                }).catch(error => {
                    console.log(error)
                        this.$toastr.e(error.response.data.message);
                        loader.hide();
                });

                loader.hide();
            },

            async getState() {
                await axios.get(api.path('lookup.state')).then(res => res.data).then(res => {
                    return this.states = res.data;
                })
            },
        }
    }

</script>
